import { useMemo } from "react";
import {
    Account,
    AccountGroupHierarchyNode,
} from "@common/types/domains/accounting/account";
import { useShowAccountNumbers } from "@hooks/useShowAccountNumbers";
import {
    AccountGroupingIdentity,
    groupAccountsByIdentity,
    MultiEntityAccount,
} from "./multiEntityAccountGrouping";

export type {
    AccountGroupingIdentity,
    MultiEntityAccount,
    MultiEntityAccountConstituent,
} from "./multiEntityAccountGrouping";

interface Params {
    accounts?: Array<Account & { entityId: number }>;
    selectedEntityIds?: number[];
    coverage?: "any" | "all";
    identity?: AccountGroupingIdentity;
    groupsByEntityId?: Map<number, AccountGroupHierarchyNode[]>;
}

export const useMultiEntityAccounts = ({
    accounts,
    selectedEntityIds,
    coverage = "any",
    identity = "nameTypeSubtype",
    groupsByEntityId,
}: Params): MultiEntityAccount[] => {
    const showAccountNumbers = useShowAccountNumbers();

    return useMemo(
        () =>
            groupAccountsByIdentity({
                accounts,
                selectedEntityIds,
                coverage,
                identity,
                groupsByEntityId,
                showAccountNumbers,
            }),
        [
            accounts,
            selectedEntityIds,
            coverage,
            identity,
            groupsByEntityId,
            showAccountNumbers,
        ],
    );
};
